var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import hive from '@bombas/hive';
import * as Styled from './Breadcrumbs.styled';
import { ContainerQueryContext } from '../../../../util/ContainerQuery.context';
import LinkText from '../../../LinkText/LinkText';
import Icon from '../../../Icons/Icon';
import { replaceStateNextCompat } from '../../../../util/history';
import { useQuickView } from '../../../QuickView/QuickView.context';
var Breadcrumbs = function (_a) {
    var _b = _a.crumbs, crumbs = _b === void 0 ? [] : _b, _c = _a.dataLabel, dataLabel = _c === void 0 ? 'breadcrumbs' : _c, props = __rest(_a, ["crumbs", "dataLabel"]);
    var _d = useQuickView(), isQuickView = _d.isQuickView, previousUrl = _d.previousUrl, PDPLink = _d.PDPLink;
    if (!(crumbs === null || crumbs === void 0 ? void 0 : crumbs.length) && !isQuickView)
        return null;
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    var handleClick = function () {
        hive.track('PDP_BREADCRUMBS_LINK_CLICK');
    };
    return (React.createElement(Styled.Breadcrumbs, __assign({ "data-label": dataLabel }, props),
        (isQuickView && crumbs.length > 2 ? crumbs.slice(0, 2) : crumbs).map(function (crumb) { return (React.createElement(Styled.Crumb, { key: crumb.name, "$styleQueryMode": styleQueryMode },
            React.createElement(LinkText, { iconPosition: "left", href: crumb.link, onClick: handleClick, icon: crumbs.length === 1 && !isQuickView ? (React.createElement(Icon, { "data-name": "icon-right", name: "arrow-left" })) : null }, crumb.name))); }),
        isQuickView && (React.createElement(Styled.Crumb, { "$styleQueryMode": styleQueryMode, "$isQuickView": isQuickView },
            React.createElement(LinkText, { href: PDPLink, icon: React.createElement(Icon, { name: "arrow-right" }), onClick: function () {
                    hive.track('QUICKVIEW_PDP_BREADCRUMB_CLICK');
                    // replaces the quickview PDP URL with the previous PCP URL so that clicking the back button will return to the PCP page instead of the PDP
                    replaceStateNextCompat(null, '', previousUrl);
                } }, "Product Page")))));
};
export default Breadcrumbs;
